import { getDifferenceInDays } from '@protector/utils/date';
import type { UUID } from '@protector/utils/types';
import moment from 'moment';
import { createSelector } from 'reselect';
import type { Selector } from '../../__legacy__/redux.types.ts';
import { Entitlements } from '../../licensing/constants.ts';
import { hasEntitlements } from '../../licensing/utils.ts';
import type { LicensingStatusAppsResponse } from '../models.ts';

const PROTECTOR_APP_ID = Object.entries(process.env).find(([key]) => key.endsWith('PROTECTOR_APP_ID'))?.[1];

export const getAppFromLastAppListByAppId = (apps: LicensingStatusAppsResponse[], appId: UUID): LicensingStatusAppsResponse | null =>
  apps
    .filter(app => app.id === appId)
    .reduce((acc: LicensingStatusAppsResponse | null, app) => {
      if (!acc) return app;
      const difference = getDifferenceInDays(new Date(acc.contract.end), new Date(app.contract.end));
      return difference < 0 ? acc : app;
    }, null);

const getProtectorLastApp: Selector<LicensingStatusAppsResponse | null> = state => {
  return getAppFromLastAppListByAppId(
    state.entities.company.licensingStatus?.apps.filter(x => {
      const today = new Date();
      return moment(today).diff(x.contract.start, 'd') >= 0;
    }) ?? [],
    PROTECTOR_APP_ID ?? ''
  );
};

export const getAppFromAppListByAppId = (apps: LicensingStatusAppsResponse[], appId: UUID): LicensingStatusAppsResponse | null =>
  apps
    .filter(app => app.id === appId)
    .reduce((acc: LicensingStatusAppsResponse | null, app) => {
      if (!acc) return app;
      const difference = getDifferenceInDays(new Date(acc.contract.start), new Date(app.contract.start));
      return difference < 0 ? acc : app;
    }, null);

export const getProtectorApp: Selector<LicensingStatusAppsResponse | null> = state => {
  const featureFlagP40_31566 = state.uiState.global.systemFlags?.P40_31566_GET_LAST_CONTRACT_HEADER;
  return featureFlagP40_31566
    ? getProtectorLastApp(state)
    : getAppFromAppListByAppId(state.entities.company.licensingStatus?.apps ?? [], PROTECTOR_APP_ID ?? '');
};

export const hasRTRPlanEntitlement: Selector<boolean> = createSelector(
  getProtectorApp,
  app => !!app && hasEntitlements(app, [Entitlements.SHOW_FARMS_WITHOUT_SEASONS])
);
